import * as o from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/Phone.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(n, { ref: t, ...r, weights: a }));
e.displayName = "PhoneIcon";
const s = e;
export {
  s as Phone,
  e as PhoneIcon
};
